import React from "react";
import ContentPage from "@/pages/ContentPage";
import CaseReportGuide from "@/components/CaseReportGuide";

export default function InstructionsForAuthors() {
  return (
    <>
      <ContentPage
        pageKey="instructions"
        defaultTitle="Instructions for Authors"
        subtitleKey="authors.page_subtitle"
      />
      <CaseReportGuide />
    </>
  );
}
